// 2025-08-06 Used Gemini 2.5 to create groupItemsByCategory

import { OmnitagResultItem } from 'packages/lib/api/omnitag/contract/omnitag-search';

/** Create a string based on the bounding box that uniquely identifies that box */
export function getBBoxStrFromImageMetadata(result: OmnitagResultItem): string {
  const [bbox] = result.bounding_box;
  return bbox
    ? `l${bbox.left_2d}t${bbox.top_2d}w${bbox.width_2d}h${bbox.height_2d}`
    : '';
}

/** Given input such as this record:
 * 
 * {
    "adult_vru": "Vulnerable Road Users",
    "ambulance": "Emergency Vehicles",
    "articulated_vehicle": "Vehicles",
    "bike_lane_sign": "Traffic Signs",
    "children": "Vulnerable Road Users",
    "children_riding_bikes": "Vulnerable Road Users",
    "speed_limit_35_sign": "Traffic Signs",
}

Creates output:

{
  "Vulnerable Road Users": [
    "adult_vru",
    "children",
    "children_riding_bikes",
  ],
  "Emergency Vehicles": [
    "ambulance",
  ],
  "Traffic Signs": [
    "bike_lane_sign",
    "speed_limit_35_sign"
  ],
}
 */
export function groupItemsByCategory(data: Record<string, string>): {
  [category: string]: string[];
} {
  return Object.entries(data).reduce((accumulator, [item, category]) => {
    if (!accumulator[category]) {
      accumulator[category] = [];
    }
    accumulator[category].push(item);
    return accumulator;
  }, {} as { [category: string]: string[] });
}
